import React, { useEffect, useMemo, useState } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import InputForm from "../../../../../components/input/input-form.jsx";

const ReportContent = ({ data }) => {
    const [highlightIndex, setHighlightIndex] = useState("");

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Indicador de OCR`, "ocr-indicator-data");
    }, [data]);

    const headers = useMemo(() => {
        if (!data) return [];
        const firstRow = data[0];
        if (!firstRow) return [];

        const sorted = [...firstRow].sort(
            (a, b) => new Date(a.s) - new Date(b.s)
        );

        return sorted.map(item => {
            const date = new Date(item.s);
            return date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit'
            });
        });
    }, [data]);

    function getCellClass(value) {
        if (highlightIndex === "" || highlightIndex === null) return "";

        if (value === null || value === undefined) return "";

        const numericValue = parseFloat(String(value).replace(',', '.'));
        const highlight = parseFloat(highlightIndex);

        if (isNaN(numericValue) || isNaN(highlight)) return "";
        if (numericValue === 0) return "cell-danger";
        if (numericValue <= highlight) return "cell-warning";

        return "";
    }

    return (
        <>
            <div class="w-full">
                <div className="index-highlighter mt-2 mb-4 flex flex-col items-end gap-2">
                    <strong>Destacar índices abaixo de (%)</strong>

                    <InputForm
                        max="100"
                        min="0"
                        type="number"
                        value={highlightIndex}
                        onChange={(e) => setHighlightIndex(e.target.value)}
                        classNameWrapper={'w-[190px]'}
                    />
                </div>

                <table id="ocr-indicator-data" className="table report-table" sheet-name="Indicador de OCR">
                    <thead className="thead-background print:table-row-group!">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className={'w-[0.5px]'}>Código</th>
                            <th className={'w-[250px]'}>Ponto</th>
                            <th className={'w-[10px]'}>Sentido</th>

                            {headers.map((header, index) => (
                                <th key={index} className="text-center">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        { data?.map((element, index) => {
                            if (!element || element.length === 0) return null;
                            const sortedElement = [...element].sort(
                                (a, b) => new Date(a.s) - new Date(b.s)
                            );

                            const { code, point, way } = sortedElement[0];

                            return (
                                <tr key={index}>
                                    <td className={'w-[0.5px]'}>{code}</td>
                                    <td className={'w-[250px] break-all'}>{point}</td>
                                    <td className={'w-[10px]'}>{way}</td>

                                    {element.map((cell, index) => {
                                        const value = cell.totidentified;

                                        return (
                                            <td key={index} className={`w-fit text-center ${getCellClass(value)}`}>
                                                {value !== null && value !== undefined ? `${value}` : 'N/D'}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;
